module.exports = __webpack_public_path__ + "img/capa1.c3593afd.webp";